import { Directive, ElementRef, inject, input } from '@angular/core';
import { PlatformService } from 'src/app/shared/services/platform.service';

// A button of the page header, projected into urban-page-actions: shown as is
// on desktop; on a phone its icon (urbanPageAction="delete") when it is the
// only one, an entry of the page menu otherwise.
@Directive({
  selector: 'button[urbanPageAction]',
  standalone: false,
  host: {
    '[class.d-none]': 'isMobile()'
  }
})
export class PageActionDirective {
  readonly icon = input<string>('', { alias: 'urbanPageAction' });

  protected readonly isMobile = inject(PlatformService).isMobileViewport;
  private readonly host: HTMLButtonElement = inject(ElementRef).nativeElement;

  get label(): string {
    return this.host.textContent?.trim() ?? '';
  }

  get warn(): boolean {
    return this.host.classList.contains('warnButton') || this.host.classList.contains('outlineWarnButton');
  }

  get disabled(): boolean {
    return this.host.disabled;
  }

  trigger(): void {
    this.host.click();
  }
}
